var l = /* @__PURE__ */ ((e) => (e.None = "None", e.Fake = "Fake", e.FirstData = "FirstData", e.Mercury = "Mercury", e.Paypal = "Paypal", e.WorldPayUk = "WorldPayUk", e.Square = "Square", e.Stripe = "Stripe", e))(l || {});
class r extends Error {
  constructor(t, c) {
    super(`[${t}] ${c}`), this.code = t;
  }
}
function U(e) {
  return Object.keys(e).map((t) => `${t}=${e[t]}`).join(",");
}
let f = null, o = null;
function H() {
  f == null || f.focus();
}
function L() {
  o = document.createElement("div"), o.style.position = "fixed", o.style.top = "0", o.style.left = "0", o.style.width = "100%", o.style.height = "100%", o.style.backgroundColor = "#343a40", o.style.opacity = "0.85", o.style.zIndex = "9999", o.onclick = () => H(), document.body.appendChild(o);
}
function O() {
  o && (document.body.removeChild(o), o = null);
}
function W() {
  O(), f == null || f.close(), f = null;
}
function B(e) {
  f && e.location.href !== f.location.href && W(), f = e;
  const t = {
    id: setTimeout(() => {
    }),
    next: () => {
      t.id = setTimeout(() => {
        if (!e.closed) return t.next();
        clearTimeout(t.id), W();
      }, 200);
    }
  };
  t.next();
}
function G(e) {
  return new Promise((t) => {
    let c = !1, s = !1;
    const { target: a, name: u, width: m, height: y, onMessage: n, shouldResolveWhen: h, eventTypeGuard: d } = e, g = (z) => z.data === "ready", E = e.readySignal ?? g, I = window.screenLeft !== void 0 ? window.screenLeft : window.screenX, b = window.screenTop !== void 0 ? window.screenTop : window.screenY, S = (screen.availWidth - m) / 2 + I, M = (screen.availHeight - y) / 2 + b, p = document.getElementById(e.targetElementId);
    if (!p)
      return t(new r("ElementNotFound", `Element with id ${e.targetElementId} not found on createPopup`));
    let v;
    p.onclick = async () => {
      const i = await new Promise((P) => {
        const R = "resizable," + U({ width: m, height: y, top: M, left: S });
        v = window.open(a, u, R), v && (B(v), L(), P(v));
      }), A = () => {
        c = !0, t({
          createdAt: /* @__PURE__ */ new Date(),
          win: i,
          target: a,
          sendMessage: (R) => i != null && i.closed ? !1 : (i == null || i.postMessage(R, "*"), !0),
          // eslint-disable-next-line @typescript-eslint/no-use-before-define
          resultAsync: N
        });
      }, N = new Promise((P) => {
        const R = (w) => {
          s = !0, P(w);
        };
        function $(w) {
          if (!s) {
            if (!c && E(w))
              return A();
            d(w) && (typeof n == "function" && n(w), h(w) && (i == null || i.close(), R(w)));
          }
        }
        window.addEventListener("message", $);
        const T = {
          id: setTimeout(() => {
          }),
          next: () => {
            T.id = setTimeout(() => {
              if (!(i != null && i.closed)) return T.next();
              clearTimeout(T.id), window.removeEventListener("message", $), s || R(new r("PopupClosed", "Popup closed before receiving result"));
            }, 200);
          }
        };
        T.next();
      });
    };
  });
}
const k = "initQhpp", _ = {
  "mybowlingpassport.com": {
    "development-beta": "https://happy-grass-09f433a03.5.azurestaticapps.net",
    "development-stable": "https://calm-field-08cd05b03.5.azurestaticapps.net",
    "staging-beta": "https://payments-staging-beta.mybowlingpassport.com",
    "staging-stable": "https://payments-staging.mybowlingpassport.com",
    "production-beta": "https://payments-beta.mybowlingpassport.com",
    "production-stable": "https://payments.mybowlingpassport.com",
    "expo-beta": "https://payments-expo-beta.mybowlingpassport.com",
    "expo-stable": ""
  },
  "qubicaamf.com": {
    "development-beta": "https://happy-grass-09f433a03.5.azurestaticapps.net",
    "development-stable": "https://calm-field-08cd05b03.5.azurestaticapps.net",
    "staging-beta": "https://payments-staging-beta.qubicaamf.com",
    "staging-stable": "https://payments-staging.qubicaamf.com",
    "production-beta": "https://payments-beta.qubicaamf.com",
    "production-stable": "https://payments.qubicaamf.com",
    "expo-beta": "https://payments-expo-beta.qubicaamf.com",
    "expo-stable": ""
  },
  "azurestaticapps.net": {
    "development-beta": "https://happy-grass-09f433a03.5.azurestaticapps.net",
    "development-stable": "https://calm-field-08cd05b03.5.azurestaticapps.net",
    "staging-beta": "https://victorious-meadow-0df04410f.5.azurestaticapps.net",
    "staging-stable": "https://mango-island-0feb1860f.5.azurestaticapps.net",
    "production-beta": "https://purple-dune-0d0a87f0f.5.azurestaticapps.net",
    "production-stable": "https://salmon-coast-0af59f00f.5.azurestaticapps.net",
    "expo-beta": "https://black-bay-0eaba7d0f.5.azurestaticapps.net",
    "expo-stable": ""
  }
}, Y = "qamf-stripe-error", j = "generic-error";
function K(e) {
  return new Promise((t) => {
    let c = !1, s = !1;
    const { onMessage: a, shouldResolveWhen: u, eventTypeGuard: m } = e, y = (b) => b.data === "ready", n = e.readySignal ?? y, h = document.getElementById(e.targetElementId);
    if (!h)
      return t(new r("ElementNotFound", `Element with id ${e.targetElementId} not found on createPopup`));
    h.innerHTML = "";
    const d = document.createElement("iframe");
    d.src = e.src, d.style.width = "100%", d.style.height = "100%", d.style.border = "none", h.appendChild(d);
    const g = d.contentWindow;
    if (!g)
      return t(new r("IframeContentWindowNull", "iFrame contentWindow is null."));
    const E = () => {
      c = !0, t({
        createdAt: /* @__PURE__ */ new Date(),
        win: g,
        sendMessage: (S) => (g.postMessage(S, "*"), !0),
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        resultAsync: I
      });
    }, I = new Promise((b) => {
      const S = (p) => {
        s = !0, b(p);
      };
      function M(p) {
        if (!s) {
          if (!c && n(p))
            return E();
          m(p) && (typeof a == "function" && a(p), u(p) && S(p));
        }
      }
      window.addEventListener("message", M);
    });
  });
}
let x = {
  environment: "production",
  channel: "stable"
}, q = "qubicaamf.com";
function J(e, t) {
  x = e, t && (q = t);
}
function C() {
  return _[q][`${x.environment}-${x.channel}`] + "";
}
function Q(e) {
  switch (e) {
    case l.Fake:
    case l.Square:
    case l.Mercury:
      return "iframe";
    case l.FirstData:
    case l.Stripe:
    case l.WorldPayUk:
      return "popup";
    default:
      return new r("Unknown", `This payment provider is unknown: ${e}`);
  }
}
function V(e) {
  return {
    ClientSecret: e.ClientSecret,
    StripeUserId: e.StripeUserId,
    PublicKey: e.PublicKey
  };
}
function X(e) {
  return {
    CurrencyID: e.CurrencyID,
    Description: e.Description,
    Symbol: e.Symbol,
    DecDigits: e.DecDigits,
    ThousandSep: e.ThousandSep,
    DecimalSep: e.DecimalSep,
    SymbolBeforeValue: e.SymbolBeforeValue,
    Conversion: e.Conversion,
    RoundType: e.RoundType,
    RoundUnit: e.RoundUnit
  };
}
const F = {
  defaultPopupWidth: 900,
  defaultPopupHeight: 660
}, D = {
  stripePopupWidth: 570,
  stripePopupHeight: 560
};
async function Z(e, t, c) {
  var y;
  const s = Q(e);
  if (s instanceof r)
    return s;
  if (!c)
    return new r("MissingParameter", `Failed to create render instance as ${s}, missing "targetElementId" parameter`);
  let a = null;
  if (s === "iframe" && c)
    a = await K({
      src: `${C()}?${k}=${Date.now()}`,
      targetElementId: c,
      eventTypeGuard(n) {
        return typeof n.data != "string" && "providerReplied" in n.data;
      },
      shouldResolveWhen: (n) => n.data.providerReplied === !0
    });
  else if (s === "popup")
    a = await G({
      target: `${C()}?${k}=${Date.now()}`,
      name: "payment",
      width: e === l.Stripe ? D.stripePopupWidth : F.defaultPopupWidth,
      height: e === l.Stripe ? D.stripePopupHeight : F.defaultPopupHeight,
      targetElementId: c,
      eventTypeGuard(n) {
        return typeof n.data != "string" && "providerReplied" in n.data;
      },
      shouldResolveWhen: (n) => n.data.providerReplied === !0
    });
  else
    return new r("UnknownRenderMode", `Render as ${s} is not implemented yet`);
  if (!a)
    return new r("RenderError", `Failed to create render instance as ${s}`);
  if (a instanceof r)
    return a;
  if (s === "popup" && ((y = a.win) == null || y.focus()), l.Stripe === e) {
    const n = t.Data, h = V(n), d = X(n), g = n.TotalAmount;
    a.sendMessage({
      command: "stripe-payment",
      payload: {
        data: h,
        currency: d,
        amount: g
      }
    });
  } else
    a.sendMessage({
      command: "redirect",
      payload: {
        url: t.Url,
        method: t.Method,
        data: t.Data
      }
    });
  const u = await a.resultAsync;
  if (!u)
    return new r("NoResult", "No result received from the payment provider.");
  if (u instanceof r)
    return u;
  if (!u.data)
    return new r("NoResultData", "No result data received from the payment provider.");
  const m = u.data.providerData.name;
  return m === Y || m === j ? new r(u.data.providerData.code, u.data.providerData.message) : {
    paymentHappened: !0,
    ...u.data
  };
}
export {
  r as PaymentError,
  l as PaymentProvider,
  Z as default,
  C as getPaymentsAppUrl,
  W as popupWindowClose,
  H as popupWindowFocus,
  Q as providerRendersAs,
  J as setup
};
